export const genericNullableValue = <T, >(
	value: T | null | undefined = undefined
): T | null | undefined => value;
